var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:(_vm.classPrefix + "__back-link"),attrs:{"href":"https://chirana.pl"}},[_c('BackArrow'),_c('span',{class:("uppercased-text " + _vm.classPrefix + "__back-text")},[_vm._v("Powrót do strony")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }